import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { b as _extends } from '../_rollupPluginBabelHelpers-05128ded.js';
import React__default, { useState } from 'react';
import Icon, { IconTypes, IconColors } from './Icon.js';
import ImageRenderer from './ImageRenderer.js';
import { h as getClassName, p as isVideoMessage, o as isGifMessage, C as isSentMessage } from '../index-579ca9d7.js';
import { n as noop } from '../utils-e0c7329c.js';
import { u as useLongPress } from '../useLongPress-12280c78.js';
import 'prop-types';
import '../utils/message/getOutgoingMessageState.js';
import '../MediaQueryContext-d6110905.js';
function ThumbnailMessageItemBody(_ref) {
  var _thumbnails$, _message$reactions$le, _message$reactions;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    message = _ref.message,
    _ref$isByMe = _ref.isByMe,
    isByMe = _ref$isByMe === void 0 ? false : _ref$isByMe,
    _ref$mouseHover = _ref.mouseHover,
    mouseHover = _ref$mouseHover === void 0 ? false : _ref$mouseHover,
    _ref$isReactionEnable = _ref.isReactionEnabled,
    isReactionEnabled = _ref$isReactionEnable === void 0 ? false : _ref$isReactionEnable,
    _ref$showFileViewer = _ref.showFileViewer,
    showFileViewer = _ref$showFileViewer === void 0 ? noop : _ref$showFileViewer,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var _message$thumbnails = message.thumbnails,
    thumbnails = _message$thumbnails === void 0 ? [] : _message$thumbnails;
  var thumbnailUrl = thumbnails.length > 0 ? (_thumbnails$ = thumbnails[0]) === null || _thumbnails$ === void 0 ? void 0 : _thumbnails$.url : '';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imageRendered = _useState2[0],
    setImageRendered = _useState2[1];
  var onClickHandler = useLongPress({
    onLongPress: noop,
    onClick: function onClick() {
      if (isSentMessage(message)) {
        showFileViewer === null || showFileViewer === void 0 ? void 0 : showFileViewer(true);
      }
    }
  });
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: getClassName([className, 'sendbird-thumbnail-message-item-body', isByMe ? 'outgoing' : 'incoming', mouseHover ? 'mouse-hover' : '', isReactionEnabled && ((_message$reactions$le = (_message$reactions = message.reactions) === null || _message$reactions === void 0 ? void 0 : _message$reactions.length) !== null && _message$reactions$le !== void 0 ? _message$reactions$le : 0) > 0 ? 'reactions' : ''])
  }, onClickHandler), /*#__PURE__*/React__default.createElement(ImageRenderer, {
    className: "sendbird-thumbnail-message-item-body__thumbnail",
    url: thumbnailUrl || (message === null || message === void 0 ? void 0 : message.url),
    alt: message === null || message === void 0 ? void 0 : message.type,
    width: (style === null || style === void 0 ? void 0 : style.width) || '360px',
    height: (style === null || style === void 0 ? void 0 : style.height) || '270px',
    onLoad: function onLoad() {
      setImageRendered(true);
    },
    placeHolder: function placeHolder(style_) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "sendbird-thumbnail-message-item-body__placeholder",
        style: style_
      });
    }
  }), isVideoMessage(message) && !thumbnailUrl && !imageRendered && /*#__PURE__*/React__default.createElement("video", {
    className: "sendbird-thumbnail-message-item-body__video"
  }, /*#__PURE__*/React__default.createElement("source", {
    src: message === null || message === void 0 ? void 0 : message.url,
    type: message === null || message === void 0 ? void 0 : message.type
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-thumbnail-message-item-body__image-cover"
  }), (isVideoMessage(message) || isGifMessage(message)) && /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-thumbnail-message-item-body__icon-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-thumbnail-message-item-body__icon-wrapper__icon"
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: isVideoMessage(message) ? IconTypes.PLAY : IconTypes.GIF,
    fillColor: IconColors.GRAY,
    width: "34px",
    height: "34px"
  }))));
}
export { ThumbnailMessageItemBody as default };